<kendo-dialog *ngIf="inputData.opened" title="{{importLblTxt.uploadItemToExcelLbl?importLblTxt.uploadItemToExcelLbl:import.uploadItemToExcelLbl}}" (close)="importDialogClose()"
              class="kendoCartPopupCls">
  <div>
    <div *ngIf="true" class="card" style="width: 100%;">
      <div class="card-body">
        <h6 class="card-subtitle mb-2 text-muted">
          <!--Requirement for Excel file upload-->
          {{importLblTxt.excelFileUploadLbl?importLblTxt.excelFileUploadLbl:import.excelFileUploadLbl}}
        </h6>
        <p class="card-text"></p>
        <ul>
          <li>
            <!--You may add any contents (like text) in row 1. Contents for row 1 will not be uploaded.-->
            {{importLblTxt.importContentLbl1?importLblTxt.importContentLbl1:import.importContentLbl1}}
          </li>
          <li>
            <!--Data from row 2 up to row 1000 will be uploaded.-->
            {{importLblTxt.importContentLbl2?importLblTxt.importContentLbl2:import.importContentLbl2}}
          </li>
          <li>
            <!--Column 1 must be the item name and column 2 must be item quantity.-->
            {{importLblTxt.importContentLbl3?importLblTxt.importContentLbl3:import.importContentLbl3}}
          </li>
          <li>
            <!--Any additional columns after column 2 will be ignored.-->
            {{importLblTxt.importContentLbl4?importLblTxt.importContentLbl4:import.importContentLbl4}}

          </li>
          <li>
            {{importLblTxt.importContentLbl5?importLblTxt.importContentLbl5:import.importContentLbl5}}
            <!--  A maximum of 999 items can be uploaded at one time from Excel. Any rows after row 1000 in the Excel file will be ignored.-->
          </li>
          <li>
            {{importLblTxt.importContentLbl6?importLblTxt.importContentLbl6:import.importContentLbl6}}
            <!-- To upload more than 999 items, you must upload them in multiple batches with a maximum of 999 items at a time.-->
          </li>
          <li>
            {{importLblTxt.importContentLbl7?importLblTxt.importContentLbl7:import.importContentLbl7}}
            <!-- Note that you can not upload configured items or kit items.-->
          </li>
          <li>
            <!-- Item quantity (column 2) must be between 1 to 999.-->
            {{importLblTxt.importContentLbl8?importLblTxt.importContentLbl8:import.importContentLbl8}}
          </li>
          <li>
            <!-- A sheet name is mandatory. Enter the correct sheet name.-->
            {{importLblTxt.importContentLbl9?importLblTxt.importContentLbl9:import.importContentLbl9}}
          </li>
          <li>
            {{importLblTxt.importContentLbl10?importLblTxt.importContentLbl10:import.importContentLbl10}} <a href="../../../../assets/docs/SampleExcelWithUOM.xlsx"
                                                                                                             class="card-link"><!--Click-->{{importLblTxt.clickLbl?importLblTxt.clickLbl:import.clickLbl}}</a>
          </li>
          <li>
           Please use only <strong>.xlsx</strong> file.
          </li>
        </ul>
      </div>
    </div>
  </div>
  <form name="uploadform" class="uploadform" style="margin: 5px 0;">
    <div style="width: 100%;">
      <span class="input-group-text"><!--Enter the Excel Details below and then click--> {{importLblTxt.importContentLbl11?importLblTxt.importContentLbl11:import.importContentLbl11}} &nbsp;<b><!--Upload-->{{importLblTxt.uploadLbl?importLblTxt.uploadLbl:import.uploadLbl}}</b>&nbsp;</span>

      <div class="input-group" style="margin: 5px 0;">
        <div class="custom-file">
          <input type="file" class="k-button btn" style="width: 100%;"
                 (change)="readExcel($event)" accept=".xlsx"
                 name="fileupload" #fileupload ngModel
                 required>
        </div>
        <div class="input-group-append">

          <button kendobutton class="k-button btnGreenBorderCls" [disabled]="importExcelItems.length<2" (click)="uploadItems()">{{importLblTxt.uploadLbl?importLblTxt.uploadLbl:import.uploadLbl}}<!--Upload--></button>
        </div>
      </div>
      <p *ngIf="inputData.isSuccess" class="text-success align-center">{{inputData.successMessage}}</p>
      <p *ngIf="inputData.isError" class="text-danger align-center">{{inputData.errorMessage}}</p>
    </div>
  </form>

</kendo-dialog>
